/* tslint:disable */
/* eslint-disable */
/**
 * Kiwi Framework
 * Kiwi API description
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Material } from './Material';
import {
    MaterialFromJSON,
    MaterialFromJSONTyped,
    MaterialToJSON,
} from './Material';

/**
 * 
 * @export
 * @interface MaterialListResponse
 */
export interface MaterialListResponse {
    /**
     * 
     * @type {Array<Material>}
     * @memberof MaterialListResponse
     */
    materials: Array<Material>;
}

/**
 * Check if a given object implements the MaterialListResponse interface.
 */
export function instanceOfMaterialListResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "materials" in value;

    return isInstance;
}

export function MaterialListResponseFromJSON(json: any): MaterialListResponse {
    return MaterialListResponseFromJSONTyped(json, false);
}

export function MaterialListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MaterialListResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'materials': ((json['materials'] as Array<any>).map(MaterialFromJSON)),
    };
}

export function MaterialListResponseToJSON(value?: MaterialListResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'materials': ((value.materials as Array<any>).map(MaterialToJSON)),
    };
}

